import { NivaBupaIcon } from "@svgs";

const QuotePageHeader = () => {
  return (
    <header className="z-3 w-full py-2 bg-white sticky top-0 col-start-1 col-end-13 grid grid-cols-12">
      <div className="col-start-2 col-end-12 flex flex-row justify-between items-center gap-8">
        <div>
          <NivaBupaIcon className="h-20 w-24 md:h-20 md:w-40" />
        </div>
        <nav className="flex flex-col lg:flex-row gap-2">
          <a
            className="flex flex-row flex-wrap justify-end"
            href="tel:1800-309-3333"
          >
            <span className="text-sm">For a new policy -</span>
            <span className="text-sm font-bold">1800-309-3333</span>
          </a>
          <a
            className="flex flex-row flex-wrap justify-end"
            href="tel:1860-500-8888"
          >
            <span className="text-sm">Customer helpline -</span>
            <span className="text-sm font-bold">1860-500-8888</span>
          </a>
        </nav>
      </div>
    </header>
  );
};

export default QuotePageHeader;
